// Radix Themes config — the web app has one (light) theme.
export const themeConfig = {
  accentColor: "green" as const,
  grayColor: "gray" as const,
  radius: "small" as const,
  scaling: "100%" as const,
  appearance: "light" as const,
};

/**
 * Radix green scale (light). Injected in `index.tsx` after Radix's own CSS so
 * it wins on `:root` and on the Radix Theme root (`.light`).
 */
export const customAccentColor = `
  :root, .light, .light-theme {
    --green-1: #f7f2e8;
    --green-2: #f0ebe0;
    --green-3: #e8efe9;
    --green-4: #dde8df;
    --green-5: #cddccf;
    --green-6: #b8ccc4;
    --green-7: #8a9e94;
    --green-8: #5e7a6b;
    --green-9: #4d675a;
    --green-10: #3e5348;
    --green-11: #3a4f42;
    --green-12: #1a2b22;

    --green-a1: #4d675a0c;
    --green-a2: #4d675a14;
    --green-a3: #4d675a1f;
    --green-a4: #4d675a2e;
    --green-a5: #4d675a3d;
    --green-a6: #4d675a4d;
    --green-a7: #4d675a5e;
    --green-a8: #4d675a72;
    --green-a9: #4d675ab3;
    --green-a10: #3e5348cc;
    --green-a11: #3a4f42;
    --green-a12: #1a2b22;

    --green-contrast: #ffffff;
    --green-surface: #f0ebe0cc;
    --green-indicator: #4d675a;
    --green-track: #8a9e94;
  }

  @supports (color: color(display-p3 1 1 1)) {
    @media (color-gamut: p3) {
      :root {
        --green-9: color(display-p3 0.29 0.4 0.35);
        --green-12: color(display-p3 0.12 0.16 0.14);
      }
    }
  }
`;

export default themeConfig;
